import { Transform, Type } from "class-transformer";
import { BaseModel } from "../base.model";
import { QuestionGroup } from "./question-group.model";
import { QuestionRangeGroupWeighting } from "./question-range-group-weighting.model";
import { QuestionRangeGroup } from "./question-range-group.model";
import { questionType } from "./question-type.model";
import { QuestionVariant } from "./question-variant.model";

export class Question extends BaseModel {
  id: number;
  name: string;
  description: string;
  qTypeId: number;
  @Transform(({ value }) => decodeURIComponent(value || ""))
  defaultValue: string | number | null;
  values?: any[];
  qEnumId: number;
  qRangeGroupId: number;
  qRangeGroupWId: number;
  @Type(() => QuestionVariant)
  questionVariants?: QuestionVariant[];
  @Type(() => Boolean)
  isQARequired: boolean;
  isDemographic: boolean;
  @Type(() => Boolean)
  isArchived: boolean;
  @Type(() => QuestionRangeGroup)
  questionRangeGroup: QuestionRangeGroup;
  @Type(() => QuestionRangeGroupWeighting)
  questionRangeGroupW: QuestionRangeGroupWeighting[];
  @Type(() => questionType)
  questionType: questionType;
  @Type(() => QuestionGroup)
  questionGroups: QuestionGroup[];

  get questionTypeName(): string | undefined {
    if (Array.isArray(this.questionType) && this.questionType.length > 0) {
      return this.questionType[0]?.name;
    }
    if (this.questionType && typeof this.questionType === "object") {
      return (this.questionType as any).name;
    }
    return undefined;
  }

  get questionGroupNames(): string {
    if (this.questionGroups && this.questionGroups.length > 0) {
      return this.questionGroups.map((qg) => qg.name).join(", ");
    }
    return "-";
  }
}
